// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ErrorFallback_wrapper__2-q4v"};